import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * The "Renew Support Contract" line a recommendation card ends with when it carries an
 * end-of-support-contract recommendation, as the legacy end-of-support-contract card does.
 */
@Component({
    selector: 'eosc-renew-call-to-action',
    templateUrl: './eosc-renew-call-to-action.component.html',
    styleUrls: ['./eosc-renew-call-to-action.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    preserveWhitespaces: false,
})
export class EoscRenewCallToActionComponent {}
